import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('component.error.state');
import { Input } from '@angular/core';

@Component({
    selector: 'wiz-component-error-state',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/component.error.state/view.scss */
:host {
  display: block;
}

.error-state {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  min-height: 180px;
  border: 0.5px solid var(--line, rgba(255, 255, 255, 0.08));
  border-radius: 18px;
  background: color-mix(in srgb, var(--surface, #1e1e30) 92%, transparent);
  padding: 26px 18px;
  color: var(--text, #e8e8f0);
  text-align: center;
}

.error-state-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 42px;
  height: 42px;
  margin-bottom: 12px;
  border-radius: 999px;
  background: rgba(239, 68, 68, 0.12);
  color: #ef4444;
  font-size: 18px;
}

.error-state-message {
  max-width: 260px;
  color: var(--text, #e8e8f0);
  font-size: 14px;
  font-weight: 800;
  line-height: 1.45;
}

.error-state-action {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 38px;
  gap: 7px;
  margin-top: 16px;
  border: 0;
  border-radius: 999px;
  background: var(--primary, #a0a8d0);
  padding: 0 16px;
  color: #12121c;
  cursor: pointer;
  font-size: 13px;
  font-weight: 900;
}

:host-context(.light-screen) .error-state-action {
  color: #ffffff;
}`],
})
export class ComponentErrorStateComponent {
    @Input() public message: string = '잠깐 문제가 생겼어. 다시 시도해줘';
    @Input() public retryLabel: string = '다시 시도';
    @Input() public onRetry?: () => void;

    public retry(): void {
        this.onRetry?.();
    }
}

export default ComponentErrorStateComponent;